<template>
  <div class="instanceParam-page">
    <Card shadow>
      <Row>
        <i-col span="21">
          <h1>{{this.$route.query.name}}</h1>
        </i-col>
        <i-col span="3">
          <Button style="float: right;" @click="refresh()" type="primary" :style="{marginBottom: '10px'}">刷新</Button>
        </i-col>
      </Row>
      <Divider />
      <Row>
        <i-col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="参数名称" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getInstanceParam()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getInstanceParam()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
      </Row>
      <tables ref="instanceParamTable" editable height="600" search-place="top" v-model="instanceParamData"
              :columns="paramColumns" @on-save-edit="editParam"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getInstanceParam"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getParamList, setParam} from '@/api/mysql'

export default {
  name: 'MySQLInstanceParam',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      paramColumns: [
        { title: '参数名', key: 'name', align: 'center', minWidth: 250 },
        { title: '默认值', key: 'default_value', align: 'center', minWidth: 100 },
        { title: '当前值', key: 'current_val', editable: true, align: 'center', minWidth: 100 },
        {
          title: '是否重启',
          key: 'dynamic',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.dynamic) {
              return h('div', '是')
            } else {
              return h('div', '否')
            }
          }
        },
        { title: '参数可选范围', key: 'ranges', align: 'center', minWidth: 150 }
      ],
      instanceParamData: []
    }
  },

  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      if (this.$route.query.id) {
        this.refresh()
      }
    }
  },

  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getInstanceParam()
    },
    refresh () {
      this.getInstanceParam()
    },
    getInstanceParam (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        search: this.searchForm.name
      }
      getParamList(params).then(res => {
        this.instanceParamData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取进程列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取进程列表失败！服务器无响应'
          })
        }
      })
    },

    editParam (params) {
      let data = {
        id: this.$route.query.id,
        param: params.row.name,
        ranges: params.row.ranges,
        aval: params.value,
        bval: params.row.current_val
      }
      setParam(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInstanceParam()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
        this.getInstanceParam()
      })
    }
  },

  mounted: function () {
    this.getInstanceParam()
  }
}
</script>
<style lang="less">
 @media screen and (max-width:640px) {
  .instanceParam-page{
    h1 {
      font-size: 1.5em;
    }
    .ivu-divider-horizontal {
      margin: 10px 0 15px;
    }
  }
 }
</style>
